import React from 'react';
import { NavLink } from 'react-router-dom';
import { Menu, X, Sparkles } from 'lucide-react';
import { OrgSwitcher } from '@/components/auth/OrgSwitcher';
import { StatusBadge } from '@/components/common/StatusBadge';
import { UserProfileMenu } from './UserProfileMenu';

interface TopNavbarProps {
  mobileMenuOpen: boolean;
  onToggleMobileMenu: () => void;
  orgTier: string;
  orgStatus: string;
  fullName?: string | null;
  orgRole?: string | null;
}

export const TopNavbar: React.FC<TopNavbarProps> = ({
  mobileMenuOpen,
  onToggleMobileMenu,
  orgTier,
  orgStatus,
  fullName,
  orgRole,
}) => {
  return (
    <header className="sticky top-0 z-40 bg-[#0C0D12]/95 border-b border-zinc-800/80 backdrop-blur-md h-16 flex items-center px-4 sm:px-6 justify-between gap-4">
      <div className="flex items-center gap-3">
        <button
          type="button"
          onClick={onToggleMobileMenu}
          className="md:hidden p-2 rounded-lg text-zinc-400 hover:text-white hover:bg-zinc-800 transition"
          aria-label="Toggle navigation menu"
        >
          {mobileMenuOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>

        <NavLink to="/" className="flex items-center gap-2.5 group">
          <div className="w-8 h-8 rounded-lg bg-linear-to-tr from-indigo-600 via-indigo-500 to-violet-500 flex items-center justify-center shadow-md shadow-indigo-500/20 group-hover:scale-105 transition-transform">
            <span className="font-black text-white text-base tracking-tighter">C</span>
          </div>
          <div className="flex flex-col">
            <span className="font-bold text-sm tracking-tight text-white flex items-center gap-1.5">
              Conversora
              <span className="text-[10px] font-semibold uppercase px-1.5 py-0.2 bg-indigo-500/15 text-indigo-400 border border-indigo-500/30 rounded-md">
                Partners
              </span>
            </span>
          </div>
        </NavLink>

        <span className="hidden sm:inline-block text-zinc-700">/</span>

        <div className="hidden sm:block">
          <OrgSwitcher />
        </div>
      </div>

      <div className="flex items-center gap-3">
        <div className="hidden md:flex items-center gap-2">
          <span className="inline-flex items-center gap-1 text-xs px-2.5 py-1 rounded-full bg-zinc-900 border border-zinc-800 text-zinc-300 font-medium">
            <Sparkles className="w-3 h-3 text-indigo-400" />
            <span className="capitalize">{orgTier} Tier</span>
          </span>
          <StatusBadge status={orgStatus} size="xs" />
        </div>

        <div className="flex items-center gap-3 border-l border-zinc-800/80 pl-3">
          <div className="hidden lg:flex flex-col text-right">
            <span className="text-xs font-medium text-zinc-200 truncate max-w-[150px]">
              {fullName}
            </span>
            <span className="text-[10px] text-zinc-400 font-mono capitalize">
              {orgRole || 'Member'}
            </span>
          </div>
          <UserProfileMenu />
        </div>
      </div>
    </header>
  );
};
